import { CATEGORY_FACETS, CATEGORY_ICONS } from '@constants/categories';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import type { CategoryCode } from '@typings/Category';
import React from 'react';
import codeToSlugNameMap from '../../../../utils/categoryNameMappings';
import Styles from './styles.scss';

interface VendorNetworkCategoryProps {
	categoryCode: CategoryCode;
	onClick?: () => void;
}

export const VendorNetworkCategory: React.FC<VendorNetworkCategoryProps> = ({
	categoryCode,
	onClick,
}) => {
	const categoryName =
		CATEGORY_FACETS[categoryCode]?.name ||
		codeToSlugNameMap[categoryCode]?.name ||
		categoryCode;
	const categoryIcon = CATEGORY_ICONS[categoryCode];

	return (
		<button type="button" className={Styles.categoryWrapper} onClick={onClick}>
			<Icon
				name={categoryIcon}
				size="md"
				color="subtle-dark"
				aria-label={categoryName}
				className={Styles.categoryIcon}
			/>
			<TextBody size="md" bold className={Styles.categoryName}>
				{categoryName}
			</TextBody>
			<Icon name="caret-right" size="sm" aria-label="Arrow right" />
		</button>
	);
};
